<template>
  <div class="fundraising-plan-container">
    <!-- 标签页导航 -->
    <div class="tab-header">
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'funding' }"
        @click="activeTab = 'funding'"
      >
        资金筹措
      </button>
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'annual' }"
        @click="activeTab = 'annual'"
      >
        分年投资计划
      </button>
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'repayment' }"
        @click="activeTab = 'repayment'"
      >
        还本付息
      </button>
    </div>

    <!-- 标签页内容 -->
    <div class="tab-content">
      <!-- 资金筹措标签页 -->
      <FundingPlan v-if="activeTab === 'funding'" :is-view-mode="isViewMode" />

      <!-- 分年投资计划标签页 -->
      <AnnualInvestmentPlan
        v-if="activeTab === 'annual'"
        :is-view-mode="isViewMode"
      />
      
      <!-- 还本付息标签页 -->
      <Repayment v-if="activeTab === 'repayment'" :is-view-mode="isViewMode" />
    </div>
  </div>
</template>

<script>
import FundingPlan from "./FundingPlan.vue";
import AnnualInvestmentPlan from "./AnnualInvestmentPlan.vue";
import Repayment from "./Repayment.vue";

export default {
  name: "FundraisingPlan",
  components: {
    FundingPlan,
    AnnualInvestmentPlan,
    Repayment,
  },
  props: {
    isViewMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: "funding", // 默认显示资金筹措标签页
    };
  },
};
</script>

<style scoped>
.fundraising-plan-container {
  padding: 20px;
  background: #f5f7fa;
}

.tab-header {
  display: flex;
  background-color: #f5f7fa;
  border-bottom: 2px solid #409eff;
  margin-bottom: 20px;
}

.tab-btn {
  padding: 12px 24px;
  border: none;
  background-color: #f5f7fa;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 4px 4px 0 0;
  margin-right: 2px;
  border-right: 1px solid #e4e7ed;
}

.tab-btn:hover {
  color: #409eff;
  background-color: #ecf5ff;
}

.tab-btn.active {
  background-color: #409eff;
  color: #fff;
}

.tab-content {
  background: white;
  border-radius: 8px;
  padding: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-height: 300px;
}
</style>
